import { DatePipe } from '@angular/common';
import { debugOutputAstAsTypeScript } from '@angular/compiler';
import { Component, ElementRef, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import * as XLSX from 'xlsx';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';


@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  columnsToHide: any = ['id', 'DOCUMENT_DETAIL_ID', 'ID'];
  lstData = [];
  menuId: number;
  reportName: string = 'Report';
  hyperlinkCols: any = ['download', 'id'];
  ToDate = "toDate";
  tbl_filter_design: any = [];
  frmReport: FormGroup;
  dateFormat = new DatePipe('en-US');
  reportType: any = "";
  queryType: any = "";
  queryProcedure: any = "";
  lst: { ParameterName: string, ParameterValue: string }[] = [];
  query: any = "";
  drilldown: any = "";
  drilldowncolumn: any = "";
  drilldownvalue: any = "";
  drilldownqueryType: any = "";
  drilldownquery: any = ""
  level: any = 0
  isBackRequest: any = false;
  constructor(private commonService: CommonService, private route: Router, private dataService: DataService, private activateRoute: ActivatedRoute, private encryptdecryptservice: EncryptDecryptService,private memorystore: MemoryStorageService) { }
  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }
  ngOnInit(): void {
    this.isBackRequest = false;
    this.menuId = this.activateRoute.snapshot.params['id'];
    if (this.commonService.reportList.length > 0) {
      this.reportName = this.commonService.reportList.find(m => m.menuId == this.menuId) ?.menuName;
    } else {
      setTimeout(() => {
        this.reportName = this.commonService.reportList.find(m => m.menuId == this.menuId) ?.menuName;
      }, 2000);
    }

    this.activateRoute.params.subscribe(p => {
      this.menuId = p['id'];
      this.reportName = this.commonService.reportList.find(m => m.menuId == this.menuId) ?.menuName;
      this.lstData = [];
      this.getTableFields();


    });

  }

  generateOfflineReport() {
    this.lst = [];
    let fieldValue;
    let obj: { ParameterName: string, ParameterValue: string };

    obj = { ParameterName: "project_id", ParameterValue: this.commonService.selectedProject };
    this.lst.push(obj);
    obj = { ParameterName: "subgroup_id", ParameterValue: this.commonService.selectedSubgroup };
    this.lst.push(obj);
    let mFields = "";

    this.tbl_filter_design.forEach(field => {

      if (field.IS_MANDATORY == 1) {

        if (field.FILTER_CONTROL == 'CALENDAR' && field.FILTER_TYPE == 'RANGE' && this.frmReport.get(field.FILTER_NAME).value != '') {
          let toDateVal, fromDateVal, field_Value;
          field_Value = this.frmReport.get(field.FILTER_NAME).value;
          fromDateVal = this.dateFormat.transform(new Date(field_Value), 'MM/dd/yyyy')
          toDateVal = this.dateFormat.transform(new Date(this.frmReport.get(this.ToDate).value), 'MM/dd/yyyy')

          if (fromDateVal == '01/01/1970' || toDateVal == '01/01/1970') {
            mFields = (mFields == "") ? field.FILTER_NAME : mFields + "," + field.FILTER_NAME;
          }


        }
        else {
          if (((this.frmReport.get(field.FILTER_NAME).value == '') ||
            (this.frmReport.get(field.FILTER_NAME).value == undefined))
            && (this.frmReport.get(field.FILTER_NAME).value != 0)) {
            mFields = (mFields == "") ? field.FILTER_NAME : mFields + ", " + field.FILTER_NAME;
          }
        }

      }
    });
    if (mFields != "") {
      this.commonService.showMessageBox("Below fields are mandatory.<br>" + mFields, "Alert");
      return;
    }

    this.tbl_filter_design.forEach(field => {
      fieldValue = this.frmReport.get(field.FILTER_NAME).value;
      if (field.FILTER_CONTROL == 'CALENDAR' && field.FILTER_TYPE == 'RANGE') {
        fieldValue = this.dateFormat.transform(new Date(fieldValue), 'MM/dd/yyyy') + '-' + this.dateFormat.transform(new Date(this.frmReport.get(this.ToDate).value), 'MM/dd/yyyy');
      } else if (field.FILTER_CONTROL == 'CALENDAR' && field.FILTER_TYPE == 'DATE') {
        fieldValue = this.dateFormat.transform(new Date(fieldValue), 'MM/dd/yyyy') + '-' + this.dateFormat.transform(new Date(fieldValue), 'MM/dd/yyyy');
      }

      if (fieldValue == undefined || fieldValue == null) {
        fieldValue = '';
      }

      obj = { ParameterName: field.FILTER_NAME, ParameterValue: fieldValue.toString() };

      this.lst.push(obj);
    });

    if (this.lst[3] == undefined || this.lst == null) {
      this.lst.push({ ParameterName: 'dummy data', ParameterValue: '' });
    }
    let body = {
      // project_id: this.commonService.selectedProject,
      PROJECTID: this.encryptdecryptservice.encryptUsingAES256(this.commonService.selectedProject),
      // report_id: this.menuId,
      reportid: this.encryptdecryptservice.encryptUsingAES256(this.menuId),
      // // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      // user_id: this.memorystore.getItem('userId'),
      encuserid: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')),
      LstParameter: this.lst
    };
    //offline 
    if (this.reportType == true) {
      this.dataService.postData('report/generate-report', body).subscribe((res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.status == true) {
            if (res.dumpdata != null) {
              this.exportAsExcelFile(res.dumpdata, this.reportName.replace(' ', '_'));
              this.commonService.showMessageBox('Your report creation request has been completed successfully.');
            } else {
              if (this.reportName == 'Audit Trail') {
                this.commonService.showMessageBox('No Data available to generate report for the requested Date Range.')
              } else {
                this.commonService.showMessageBox('No Data available to generate report for the requested DocumentType and Date.');
              }
            }
            // this.commonService.showMessageBox('Your report creation request has been submitted successfully.<br> Please check this page after about 30 minutes.', 'Success');

            this.getTableFields();
            this.getData();
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
        error => {
          if (error.includes("401")) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
        });
    }
    //standared
    else {
      this.getStandardReportData(this.lst)
    }

  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, ReportComponent.toExportFileName(excelFileName));
  }

  static toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  onGridCellClick(event: any) {
    if (event.columnName.toLowerCase() == 'download') {
      //this.commonService.openAttachment('', event.rowData.Path);
      this.commonService.openReportAttachment('', event.rowData.Path);
    }
    if (this.drilldown == true) {
      let drilldownColumns: any = [];
      drilldownColumns = this.drilldowncolumn.split(',');
      if (drilldownColumns != null && drilldownColumns != undefined) {
        drilldownColumns.forEach((col: any, Index: number) => {
          if (event.columnName.toLowerCase() == col.toLowerCase()) {
            this.isBackRequest = true;
            this.GetDrillDownReportData(this.lst, event.rowData.ID, col);
          }
        });
      }
    }
  }

  getData() {

    this.lstData = [];

    let body = {
      // project_id: this.commonService.selectedProject,
      // role_id: this.commonService.selectedRole,
      // subgroup_id: this.commonService.selectedSubgroup,
      // // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      // user_id: this.memorystore.getItem('userId'),
      // menu_id: this.menuId
      PROJECTID: this.encryptdecryptservice.encryptUsingAES256(this.commonService.selectedProject),
      ROLEID: this.encryptdecryptservice.encryptUsingAES256(this.commonService.selectedRole),
      SUBGROUPID: this.encryptdecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup),
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      encuserid: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')),
      menu_id: this.menuId
    };

    this.dataService.postData('report/get-report-output', body).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.status == true) {
          this.lstData = res.data;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  getTableFields() {
    let body = {
      // project_id: this.commonService.selectedProject,
      // role_id: this.commonService.selectedRole,
      // subgroup_id: this.commonService.selectedSubgroup,
      // // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      // user_id: this.memorystore.getItem('userId'),
      // menu_id: this.menuId
      PROJECTID: this.encryptdecryptservice.encryptUsingAES256(this.commonService.selectedProject),
      ROLEID: this.encryptdecryptservice.encryptUsingAES256(this.commonService.selectedRole),
      SUBGROUPID: this.encryptdecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup),
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      encuserid: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')),
      menu_id: this.menuId
    };
    this.dataService.postData('report/get-report-filterfields', body).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.status == true) {
          if (res.data[0].FILTER != "") {
            this.tbl_filter_design = JSON.parse(res.data[0].FILTER);
          }
          this.reportType = res.data[0].IS_OFFLINE;
          this.queryType = res.data[0].QUERY_TYPE;
          this.query = res.data[0].QUERY;
          this.drilldown = res.data[0].IS_DRILDOWN;
          this.drilldowncolumn = res.data[0].DRILDOWN_COLUMN;
          this.drilldownqueryType = res.data[0].D_QUERY_TYPE;
          this.drilldownquery = res.data[0].D_QUERY;
          this.generateFilterFields();

          if (this.reportType == true) {
            this.getData();
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });

  }
  async generateFilterFields() {

    //this. tbl_filter_design = [{"DISPLAY_FILTER_NAME":"DURATION","FILTER_NAME":"DURATION","FILTER_TYPE":"RANGE","VALUE":"","IS_DEPENDNT":"","DEPENDENT_FILTER_NAME":"","FILTER_CONTROL":"CALENDAR","IS_MANDATORY":"1"}];
    //  this. tbl_filter_design =  [{"DISPLAY_FILTER_NAME":"DURATION","FILTER_NAME":"DURATION","FILTER_TYPE":"DATE","VALUE":"","IS_DEPENDNT":"","DEPENDENT_FILTER_NAME":"","FILTER_CONTROL":"CALENDAR","IS_MANDATORY":"1","QUERY_TYPE":
    // "PROCEDURE","QUERY":"","QUERYPARAMETER":"","QUERYPARAMETERVALUE":""},
    // {"DISPLAY_FILTER_NAME":"USER","FILTER_NAME":"USER","FILTER_TYPE":"DROPDOWN","VALUE":"","IS_DEPENDNT":"","DEPENDENT_FILTER_NAME":"","FILTER_CONTROL":"DROPDOWN","IS_MANDATORY":"1","QUERY_TYPE":
    // "PROCEDURE","QUERY":"REPORT.GET_USERS","QUERYPARAMETER":"PROJECT_ID,SUBGROUP_ID","QUERYPARAMETERVALUE":"19,439"}]

    const formControls: any = {};
    this.tbl_filter_design.forEach(async (x) => {

      formControls[x.FILTER_NAME] = new FormControl();

      // if (x.FILTER_CONTROL == 'DROPDOWN') {
      //   x.options = await this.getDropDownData(x.FILTER_QUERY_ID);
      // }

      if (x.FILTER_CONTROL == 'DROPDOWN' || x.FILTER_CONTROL == 'MULIPLECHECKBOX') {
        //x.options = await this.getDropDownData(x.FILTER_QUERY_ID);
        x.options = await this.getDropDownData(x.QUERY_TYPE, x.QUERY, x.QUERYPARAMETER, x.QUERYPARAMETERVALUE, x.QUERY)
      }
    });

    formControls[this.ToDate] = new FormControl();
    this.frmReport = new FormGroup(formControls);

  }

  async getDropDownData(QueryType: any, QueryProc: any, QueryParameter: any, QueryParameterValue: any, QueryProcName: any): Promise<any> {

    let lstParameter: { ParameterName: string, ParameterValue: string }[] = [];
    let objParameter: { ParameterName: string, ParameterValue: string };

    objParameter = { ParameterName: "project_id", ParameterValue: this.commonService.selectedProject };
    lstParameter.push(objParameter);
    objParameter = { ParameterName: "subgroup_id", ParameterValue: this.commonService.selectedSubgroup };
    lstParameter.push(objParameter);
    //Additonal parameters from json
    let str_array1 = QueryParameter.split(',');
    let str_array2 = QueryParameterValue.split(',');
    if (str_array1.length == str_array2.length && str_array1.length > 0) {
      for (var i = 0; i < str_array1.length; i++) {
        objParameter = {
          ParameterName: str_array1[i],
          ParameterValue: str_array2[i]
        };
        lstParameter.push(objParameter);
      }
    }
    let params = {
      view_action: "BIND_OFFLINE_REPORT_DROPDOWN",
      menu_id: this.menuId,
      "QueryType": QueryType,
      "LstParameter": lstParameter,
      "QueryProcedureName": QueryProcName,

    };
    const result = await this.dataService.postData('report/GET_OFFLINE_BINDDROPDOWN', params).toPromise();
    if (result != null && (result.error_message == null || result.error_message == "")) {
      const uniqueData = [...new Map(result.data.map(item => [item['DROPDOWN_TEXT'], item])).values()];
      return uniqueData;
    }
    else {
      if (result.errorCode != 0 && result.errorCode == 4000) {
        this.route.navigateByUrl('/unauthorized');
        return;
      }
      if (result.errorCode != 0 && result.errorCode == 3000) {
        this.commonService.showMessageBox("Internal error")
      }
    }
  }

  getStandardReportData(listParameter: any) {

    this.lstData = [];

    let body = {
      // project_id: this.commonService.selectedProject,
      // role_id: this.commonService.selectedRole,
      // subgroup_id: this.commonService.selectedSubgroup,
      // // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      // user_id: this.memorystore.getItem('userId'),
      // LstParameter: listParameter,
      // QueryType: this.queryType,
      // QueryProcedureName: this.query
      PROJECTID: this.encryptdecryptservice.encryptUsingAES256(this.commonService.selectedProject),
      ROLEID: this.encryptdecryptservice.encryptUsingAES256(this.commonService.selectedRole),
      SUBGROUPID: this.encryptdecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup),
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      encuserid: this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')),
      LstParameter: listParameter,
      QueryType: this.queryType,
      QueryProcedureName: this.query
    };

    this.dataService.postData('report/get-report-standard-output', body).subscribe((res) => {
      if (res.status == true) {
        if (this.drilldown == true) {
          let drilldownColumns: any = [];

          drilldownColumns = this.drilldowncolumn.split(',');

          if (drilldownColumns != null && drilldownColumns != undefined) {
            drilldownColumns.forEach((col: any, Index: number) => {
              this.hyperlinkCols.push(col);
            });
          }
          //  this.hyperlinkCols.push(this.drilldowncolumn);
        }
        this.lstData = res.data;
      }
    });
  }

  GetDrillDownReportData(listParameter: any, drilldownevent: any, drilldownvalue: any) {
    let obj: { ParameterName: string, ParameterValue: string };

    obj = { ParameterName: "DRILDOWN_COLUMN_EVENT", ParameterValue: drilldownevent };
    listParameter.push(obj);
    obj = { ParameterName: "DRILDOWN_COLUMN_VALUE", ParameterValue: drilldownvalue };
    listParameter.push(obj);

    this.lstData = [];

    let body = {
      project_id: this.commonService.selectedProject,
      role_id: this.commonService.selectedRole,
      subgroup_id: this.commonService.selectedSubgroup,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      LstParameter: listParameter,
      QueryType: this.drilldownqueryType,
      QueryProcedureName: this.drilldownquery
    };

    this.dataService.postData('report/get-report-standard-output', body).subscribe((res) => {
      if (res.status == true) {
        this.lstData = res.data;
      }
    });


  }
  GetDatabasedOnFlag() {
    this.isBackRequest = false;
    this.getTableFields();
    if (this.reportType == 1) {
      this.getData();
    }
    else {
      this.lstData = [];
    }
  }
  loadBack() {
    this.isBackRequest = false;
    this.generateOfflineReport();

  }


}
